/**
 * @file components/Bullet/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { BULLET } from "./constants";

/**
 * Displays a bullet point.
 *
 * @returns {React.Component} The defined component
 */
export function Bullet() {
    return (
        <span className="bullet" data-testid="bullet">
            {BULLET}
        </span>
    );
}

export default Bullet;
